import React, { useContext, useEffect, useState } from "react";
import { View } from "@/styles/reactnative";
import { DepositLeftSectionWrapper } from "../styles";
import DepositAutoChanneled from "./DepositAutoChanneled";
import DepositChainType from "./DepositChainType";
import DepositCoins from "./DepositCoins";
import DepositQrCode from "./DepositQrCode";
import DepositWalletAddress from "./DepositWalletAddress";
import { useDepositStore } from "../../../hooks/deposit/store";
import { Button, Col, InputNumber, message, Row, Space } from "antd";
import { IconSend } from "@tabler/icons-react";
import API from "../../../../utils/api";
import { useToken } from "../../../hooks";
import { useFetcherPublic } from "../../../hooks/fetcher";
import BigNumber from "bignumber.js";
import { ThemeContext } from "../../../../theme/ThemeProvider";
import { useMyProfile } from "../../../hooks/user/myprofile";
import {useIsMobile} from "@utils/CalVW.tsx";

const DepositLeftSection = ({ width = "100%" }) => {
  const { data: depositStore } = useDepositStore({
    network: "TRC20",
    coin: "USDT",
  });

  const isMobile = useIsMobile();

  const { textw } = useContext(ThemeContext).theme.COLORS;

  const [refresh, setRefresh] = useState(false);
  const currencyList = useFetcherPublic("/system/currency");

  const equivusd = currencyList?.data?.result?.result?.find(
    (item: any) => item?.code === "KRW",
  );

  useEffect(() => {
    setTimeout(() => {
      setRefresh(!refresh);
    }, 500);
  }, [depositStore?.coin, depositStore?.network]);

  const { data } = useMyProfile();

  /*
	const { data: bank1 } = useFetcherSetting('CBANK1')
	const { data: bank2 } = useFetcherSetting('CBANK2')
	const { data: bank3 } = useFetcherSetting('CBANK3')
	*/

  const { data: token } = useToken();
  const [amount, setAmount] = useState<any>(0);
  const [name, setName] = useState("");
  return (
    (<DepositLeftSectionWrapper style={{ width: isMobile ? '100%' : width }}>
      <View style={{ paddingInline: 15, paddingBlock: 10 }}>

        <DepositCoins />


        {/* {depositStore?.coin === "KRW" ? (
          <View
            style={{
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: 20,
              width: "100%",
            }}
          >
            <Row align={"middle"} style={{ marginBottom: 10 }}>
              <Col span={isMobile ? 10 : 6} style={{ color: textw, marginBottom: isMobile ? 10 : undefined }}>
                Request Amount
              </Col>
              <Col span={isMobile ? 17 : 13}>
                <InputNumber
                  value={amount}
                  formatter={(value) =>
                    `${value}`
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      ?.replace(/[^0-9,]/g, "")
                  }
                  parser={(value) =>
                    value!.replace(/\$\s?|(,*)/g, "")?.replace(/[^0-9]/g, "")
                  }
                  step={10}
                  onChange={(e) => setAmount(e)}
                  style={{
                    textAlign: "right",
                    width: "95%",
                    flex: 1,
                  }}
                />
              </Col>
              <Col span={1} style={{ color: textw }}>
                $
              </Col>
              <Col span={isMobile ? 12 : 4} style={{marginBlock: isMobile ? 10 : undefined}}>
                <Button
                  size="small"
                  onClick={() => {
                    setAmount(0);
                  }}
                >
                  RESET
                </Button>
              </Col>
            </Row>
            <Row
              align={"middle"}
              style={{
                width: "100%",
                flex: 1,
                marginBottom: 20,
                paddingBottom: 20,
                borderBottom: "1px solid #999",
              }}
            >
              <Col
                span={24}
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                }}
              >
                <Space.Compact
                  size={"small"}
                  style={{ flex: 1, width: "100%", gap: isMobile ? 10 : 0 }}
                  direction={isMobile ? 'vertical' : 'horizontal'}
                >
                  <Button
                    size="small"
                    style={{ width: "100%", flex: 1 }}
                    onClick={() => {
                      setAmount(amount + 1000);
                    }}
                  >
                    +1000$
                  </Button>
                  <Button
                    size="small"
                    style={{ width: "100%", flex: 1 }}
                    onClick={() => {
                      setAmount(amount + 500);
                    }}
                  >
                    +50$
                  </Button>
                  <Button
                    size="small"
                    style={{ width: "100%", flex: 1 }}
                    onClick={() => {
                      setAmount(amount + 10);
                    }}
                  >
                    +10$
                  </Button>
                  <Button
                    size="small"
                    style={{ width: "100%", flex: 1 }}
                    onClick={() => {
                      setAmount(amount + 5);
                    }}
                  >
                    +5$
                  </Button>
                  <Button
                    size="small"
                    style={{ width: "100%", flex: 1 }}
                    onClick={() => {
                      setAmount(amount + 1);
                    }}
                  >
                    +1$
                  </Button>
                </Space.Compact>
              </Col>
            </Row>
            <Row
							align={'middle'}
							style={{ width: '100%', flex: 1, marginBottom: 5 }}>
							<Col span={6} style={{ color: textw }}>
								환산금액
							</Col>
							<Col
								span={18}
								style={{
									flexDirection: 'row',
									display: 'flex',
									alignItems: 'center',
								}}>
								<Input
									type="text"
									style={{
										flex: 1,
										background: '#eeeeff',
										fontWeight: 'bold',
										textAlign: 'right',
										paddingRight: 50,
									}}
									value={new BigNumber(amount)
										.dividedBy(equivusd?.price)
										.toFixed(2)}
									readOnly></Input>{' '}
								<div
									style={{
										color: 'black',
										position: 'absolute',
										right: 5,
									}}>
									USDT
								</div>
							</Col>
						</Row>
            <Row
							align={'middle'}
							style={{ width: '100%', flex: 1, marginBottom: 5 }}>
							<Col span={6} style={{ color: textw }}>
								입금자명
							</Col>
							<Col
								span={18}
								style={{
									flexDirection: 'row',
									display: 'flex',
									alignItems: 'center',
								}}>
								<Input
									type="text"
									value={name}
									onChange={e =>
										setName(e.target.value)
									}></Input>
							</Col>
						</Row>
            <Row
							align={'middle'}
							style={{
								width: '100%',
								flex: 1,
								marginBottom: 5,
								borderBottom: '1px solid #888',
								paddingBottom: 8,
							}}>
							<Col span={6} style={{ color: textw }}>
								$ 환율
							</Col>
							<Col span={18}>
								<Input
									type="text"
									value={equivusd?.price}
									readOnly></Input>
							</Col>
						</Row>
            <Button
              type="primary"
              icon={<IconSend size={14} />}
              style={{ width: "100%", flex: 1, 
              backgroundColor: "#F87943",
               }}
              onClick={() => {
                // if (!name) {
                // 	message.error('입금자명은 필수입니다.')
                // 	return
                // }

                if (!amount) {
                  //message.error('신청금액은 필수입니다.')
                  message.error(`request amount is required.`);
                  return;
                }

                API.post("/cash/request", token + "", {
                  type: "D",
                  amount: new BigNumber(amount).toFixed(2),
                  bankaccount: data?.vaccount,
                  name,
                }).then((res) => {
                  if (res?.result?.success) {
                    message.success("Successfully requested deposit.");
                  } else {
                    message.error(
                      res?.result?.message || "Failed to request deposit.",
                    );
                  }
                });
              }}
            >
              Request Deposit
            </Button>
          </View>
        ) : (
          <>
            <DepositChainType />
            <DepositQrCode />
          </>
        )} */}

     
            <DepositChainType />
            <DepositQrCode />
       
        <DepositWalletAddress />
        <DepositAutoChanneled />
      </View>
    </DepositLeftSectionWrapper>)
  );
};

export default DepositLeftSection;
